<script lang="ts">
  import { modalDialog } from "@/actions/modalDialog";
  import TextInput from "@/components/TextInput.svelte";
  import { modal } from "@/stores/modal";

  let input = $state("");

  $effect(() => {
    const request = $modal;
    if (!request) {
      return;
    }
    input = request.value ?? "";
  });

  function close(result: boolean | string | null): void {
    const request = $modal;
    if (!request) {
      return;
    }
    modal.set(null);
    request.resolve(result);
  }

  function submit(): void {
    if (!$modal) {
      return;
    }
    close($modal.kind === "prompt" ? input : true);
  }

  function cancel(): void {
    close(null);
  }
</script>

{#if $modal}
  <dialog
    class="modal"
    use:modalDialog={{
      onDismiss: cancel,
      initialFocus: $modal.kind === "prompt" ? "input" : ".ghost-button",
    }}
    aria-labelledby="modal-title"
    aria-describedby={$modal.message ? "modal-message" : undefined}
  >
    <p class="eyebrow">Подтверждение действия</p>
    <h2 id="modal-title">{$modal.title}</h2>
    {#if $modal.message}<p id="modal-message" class="modal-message">{$modal.message}</p>{/if}
    {#if $modal.kind === "prompt"}
      <TextInput
        bind:value={input}
        placeholder={$modal.placeholder}
        aria-label={$modal.title}
        onkeydown={(event: KeyboardEvent) => event.key === "Enter" && submit()}
      />
    {/if}
    <div class="modal-actions">
      <button
        class="ghost-button"
        type="button"
        onclick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          cancel();
        }}>Отмена</button
      >
      <button class="button" type="button" onclick={submit}
        >{$modal.confirmLabel ?? "Подтвердить"}</button
      >
    </div>
  </dialog>
{/if}

<style>
  .modal::backdrop {
    background: rgb(8 7 6 / 72%);
    backdrop-filter: blur(5px);
  }

  .modal {
    width: min(calc(100% - 2rem), 30rem);
    max-height: calc(100dvh - 2rem);
    overflow-y: auto;
    margin: auto;
    color: var(--cream);
    display: grid;
    gap: 0.9rem;
    padding: clamp(1.4rem, 4vw, 2.2rem);
    border: 1px solid var(--line-strong);
    border-radius: 2px;
    background: var(--surface);
    box-shadow: 0 1.5rem 5rem rgb(0 0 0 / 35%);
  }

  .modal h2,
  .modal-message {
    margin: 0;
  }

  .modal h2 {
    font: 500 clamp(1.25rem, 4vw, 1.7rem)/1.1 var(--font-display);
    text-transform: uppercase;
  }

  .modal-message {
    color: var(--muted);
    line-height: 1.5;
  }
  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.7rem;
    margin-top: 0.4rem;
  }

  @media (max-width: 420px) {
    .modal-actions {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }
</style>
